import React, { useState, useEffect } from 'react';

export default function ResetPassword({ navigate }) {
  const [token, setToken] = useState('');
  const [form, setForm] = useState({ newPassword: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (t) setToken(t);
    else setErr('No reset token found. Please request a new reset link.');
  }, []);

  const submit = async e => {
    e.preventDefault();
    if (form.newPassword !== form.confirm) { setErr('Passwords do not match'); return; }
    setLoading(true); setErr('');
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: form.newPassword })
      });
      const data = await res.json();
      if (res.ok) setDone(true);
      else setErr(data.error);
    } catch { setErr('Connection failed.'); }
    setLoading(false);
  };

  if (done) return (
    <div className="auth-wrap">
      <div className="auth-card fade-in" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
        <div style={{ fontFamily: 'var(--ff-d)', fontSize: 20, fontWeight: 800, marginBottom: 8 }}>Password Reset!</div>
        <div style={{ color: 'var(--text2)', marginBottom: 24 }}>Your password has been changed. You can now log in.</div>
        <button className="btn btn-primary" onClick={() => navigate('/login')}>Go to Login →</button>
      </div>
    </div>
  );

  return (
    <div className="auth-wrap">
      <div className="auth-card fade-in">
        <div className="auth-logo">
          <span style={{ fontSize: 36 }}>🧬</span>
          <div style={{ fontFamily: 'var(--ff-d)', fontSize: 20, fontWeight: 800, marginTop: 6 }}>Enpower Org DNA™</div>
        </div>
        <h2 className="auth-title">Set new password</h2>

        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <div style={{position:'relative'}}>
            <input className="form-input" type={showPw?'text':'password'} placeholder="Min 6 characters"
              value={form.newPassword} onChange={e=>setForm({...form,newPassword:e.target.value})} required minLength={6} style={{paddingRight:40}}/>
            <span onClick={()=>setShowPw(p=>!p)} style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',cursor:'pointer',fontSize:16,color:'var(--text-3)',userSelect:'none'}}>
              {showPw?'🙈':'👁'}
            </span>
          </div>
          </div>
          <div className="form-group">
            <label className="form-label">Confirm Password</label>
            <div style={{position:'relative'}}>
            <input className="form-input" type={showConfirm?'text':'password'} placeholder="Repeat password"
              value={form.confirm} onChange={e=>setForm({...form,confirm:e.target.value})} required style={{paddingRight:40}}/>
            <span onClick={()=>setShowConfirm(p=>!p)} style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',cursor:'pointer',fontSize:16,color:'var(--text-3)',userSelect:'none'}}>
              {showConfirm?'🙈':'👁'}
            </span>
          </div>
          </div>
          {err && <div className="form-error" style={{ marginBottom: 14 }}>{err}</div>}
          <button className="btn btn-primary" style={{ width: '100%', padding: '11px' }} disabled={loading || !token}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
